// Searching existing commercial contacts among the records already loaded (pure, tested by
// scripts/test-followup-panel.mjs). Only reads: searching or choosing never creates or changes anything.
// Shared by the global search (⌘K) and Hoy's «Registrar seguimiento».

const fold = (v) => String(v ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
const linked = (r, k) => (Array.isArray(r?.fields?.[k]) ? r.fields[k].map(x => (typeof x === 'string' ? x : x?.id)).filter(Boolean) : []);

/**
 * Contacts whose name, last name, email, role or company match every word typed (accents and case aside), best
 * first (a name that starts with the text, then a name that contains it, then the rest). All loaded contacts are
 * searched (no cut before searching); only the results are limited.
 */
export function searchContacts(stakeholders = [], accounts = [], q = '', limit = 12) {
  const words = fold(q).split(/\s+/).filter(Boolean);
  if (!words.length || fold(q).trim().length < 2) return [];
  const accName = new Map(accounts.map(a => [a.id, String(a.fields?.['Account Name'] || '')]));
  const hits = [];
  for (const s of stakeholders) {
    const f = s.fields || {};
    const name = `${f['Name'] || ''} ${f['Last name'] || ''}`.trim();
    const company = linked(s, 'Account').map(id => accName.get(id) || '').filter(Boolean).join(', ');
    const hay = fold(`${name} ${f['Email'] || ''} ${f['Role'] || ''} ${company}`);
    if (!words.every(w => hay.includes(w))) continue;
    const n = fold(name);
    const rank = n.startsWith(words[0]) ? 0 : n.includes(words[0]) ? 1 : 2;
    hits.push({ type: 'contact', id: s.id, record: s, label: name || String(f['Email'] || '(sin nombre)'), sub: [f['Role'], company, f['Email']].filter(Boolean).join(' · '), rank });
  }
  return hits.sort((a, b) => a.rank - b.rank || a.label.localeCompare(b.label, 'es')).slice(0, limit);
}
